import { ICommonContentBuilderItem, ILogo } from '@commonTypes/common';

export interface IRoot32 extends ICommonContentBuilderItem {
  title?: string;
  picture?: ILogo;
  tooltips?: Tooltip[];
  position: Position;
}

export interface Tooltip {
  id: string;
  text?: string;
  xAxis?: number;
  yAxis?: number;
}

export interface Position {
  id: 0 | 1 | 2;
  name: IMG_WIDTH.STANDARD | IMG_WIDTH.CONTAINER_WIDTH | IMG_WIDTH.FULL;
}

export enum IMG_WIDTH {
  STANDARD = 'Standart',
  CONTAINER_WIDTH = 'Container Width',
  FULL = 'Full Width',
}
